import type React from 'react';

import Icon from '@cobliteam/ui/icons';

import Button from '@cobliteam/ui/components/Button';
import DropdownMenu from '@cobliteam/ui/components/DropdownMenu';
import Tooltip from '@cobliteam/ui/components/Tooltip';

export interface DataTableActionsProps {
  children: React.ReactNode;
  dataTour?: string; // Use to add data-tour attribute to the trigger button
  modal?: boolean;
  disabled?: boolean;
  enableTooltip?: boolean;
  tooltipContent?: string;
}

const DataTableActions = ({ children, dataTour, modal, disabled, enableTooltip, tooltipContent }: DataTableActionsProps) => {
  // Can't nest Tooltip and DropdownMenu Trigger directly
  // https://github.com/radix-ui/primitives/discussions/560
  const disabledButton = (
    <Tooltip enable={enableTooltip} content={tooltipContent}>
      <Button disabled={disabled} variant='outlined' color='default' size='sm' icon={<Icon name='ellipsis' />} data-testid='datatable-actions' />
    </Tooltip>
  );

  return (
    <div className='flex justify-center'>
      <DropdownMenu modal={modal}>
        <DropdownMenu.Trigger asChild data-tour={dataTour}>
          {disabled ? disabledButton : <Button disabled={disabled} variant='outlined' color='default' size='sm' icon={<Icon name='ellipsis' />} data-testid='datatable-actions' />}
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align='end'>{children}</DropdownMenu.Content>
      </DropdownMenu>
    </div>
  );
};

export default DataTableActions;
